import absoluteUrl from 'next-absolute-url'

import TermAndCondition from 'containers/TermAndCondition'

import Layout from 'components/Layout'
import MetaTags from 'components/MetaTags'

import { data } from 'constant/term-legal-policy'

export default function Index({ canonical }) {
  const title =
    data?.termCondition?.title || 'ข้อกำหนดและเงื่อนไขในการใช้บริการ (Terms and Conditions)'
  const metaTitle = `24FIX | ${title}`
  const metaDescription = `24FIX | ${title}`

  return (
    <>
      <MetaTags title={metaTitle} description={metaDescription} pathUrl={canonical} />

      <Layout>
        <TermAndCondition data={data} />
      </Layout>
    </>
  )
}

export async function getServerSideProps(context) {
  const { req } = context
  const { origin } = absoluteUrl(req)

  return {
    props: JSON.parse(
      JSON.stringify({
        canonical: `${origin}/terms-and-conditions`,
      })
    ),
  }
}
